import cx from "classnames";
import { type FC, memo, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { canv } from "@/canv/global";
import type { MoreStickersTool } from "@/tools/moreTool/MoreStickersTool";
import type { CachedStickerType } from "./stickerCache";
import { stickerCache } from "./stickerCache";
import style from "./stickersWindow.module.css";

type StickersProps = {
    stickers: CachedStickerType[];
    searchQuery: string;
};

export const Stickers: FC<StickersProps> = memo(({ stickers, searchQuery }) => {
    const { t } = useTranslation();
    const itemClick = useCallback((path: string) => {
        const moreStickerTool = canv.toolBox.TryGetToolByName(
            "moreStickerTool",
        ) as MoreStickersTool;
        moreStickerTool.setUrl(path);

        canv.toolBox.switchTo(moreStickerTool);
        canv.redraw();
    }, []);

    const stickersClassName = cx(style.stickersWindowContent, "scrollable");

    if (searchQuery && !stickers.length) {
        return <div className={style.emptyText}>{t("stickers.empty")}</div>;
    }

    return (
        <>
            {searchQuery && !!stickers.length && (
                <div className={style.searchResultText}>{t("stickers.searchResults")}</div>
            )}
            <div className={stickersClassName}>
                {stickers.map((sticker) => {
                    const path = sticker.imageUrl || stickerCache.getImageUrl(sticker.name);

                    return (
                        <div
                            onMouseDown={() => itemClick(path)}
                            className={style.stickersWindowContentItem}
                            key={sticker.name}
                        >
                            <img
                                src={path}
                                aria-label={t("stickers.ariaLabel")}
                                alt={sticker.name}
                            />
                        </div>
                    );
                })}
            </div>
        </>
    );
});
